import { MedewerkersOpStation } from "@/entities/medewerkers-op-station";
import { Dot } from "@/shared/components";
import { cn } from "@/shared/utils";

type MedewerkersStationBemenstIndicatorProps = {
    station: MedewerkersOpStation;
    disabled: boolean;
};

export function MedewerkersStationBemenstIndicator({ station, disabled }: MedewerkersStationBemenstIndicatorProps) {
    return (
        <div className="flex items-center gap-2">
            <Dot size="s" className={cn(disabled && "opacity-50")} />
            <span className={cn(disabled && "opacity-50")}>{station.bemenst ? "Bemenst" : "Onbemenst"}</span>
        </div>
    );
}
